import React, { memo, useCallback } from "react";

import colors from "app/colors";
import { HelpIcon, LockIcon } from "modules/icons";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import {
  MODAL_TYPE,
  useOverlay,
} from "modules/providers/overlay-provider/overlay-provider";
import { Text } from "@chakra-ui/react";

const MakePrivateHelpButton = () => {
  const { openModal } = useOverlay();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.HELP,
        helpModal: {
          icon: <LockIcon boxSize={16} fill={colors.blackSecondary} />,
          title: "Private Threads",
          message: (
            <>
              <Text fontSize={13}>
                Set threads to “Private” to prevent anyone in the thread from
                adding users and groups to it.
              </Text>
              <Text fontSize={13}>
                Only the person who makes it Private can remove the setting
              </Text>
            </>
          ),
        },
      });
    },
    [openModal],
  );

  return (
    <CircularIconButton
      icon={<HelpIcon boxSize={4} fill={colors.gray40} />}
      minW={6}
      h={6}
      aria-label="help info"
      onClick={onClick}
    />
  );
};

export default memo(MakePrivateHelpButton);
